const privateInfo = {
    REACT_APP_INFURA_ID: "Your Infura ID",
    REACT_APP_PRIVATE_KEY: "Your Private Key",
    REACT_APP_API_KEY: "Your API Key"
}

export default privateInfo;
